import { UPLOAD_FILE } from "../constants/constants";

export const uploadfile = (name, value) => {
  return {
    type: UPLOAD_FILE,
    name: name,
    payload: value,
  };
};
